export default "__VITE_ASSET__DrSZnArE__"